import { render, staticRenderFns } from "./Dossier.vue?vue&type=template&id=edf7ba5e&scoped=true&"
import script from "./Dossier.vue?vue&type=script&lang=js&"
export * from "./Dossier.vue?vue&type=script&lang=js&"
import style0 from "./Dossier.vue?vue&type=style&index=0&id=edf7ba5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf7ba5e",
  null
  
)

export default component.exports